module.exports = __webpack_public_path__ + "img/bst_logo.fff18f42.png";